import { render, staticRenderFns } from "./InternalMovements.vue?vue&type=template&id=66226caf&scoped=true"
import script from "./InternalMovements.vue?vue&type=script&lang=js"
export * from "./InternalMovements.vue?vue&type=script&lang=js"
import style0 from "./InternalMovements.vue?vue&type=style&index=0&id=66226caf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66226caf",
  null
  
)

export default component.exports